module.exports = __webpack_public_path__ + "static/media/image-grouped.bd6b547c.png";